import { createApiCall } from 'lib/base';

const CREATE_HOME_WIDGET_BANNER = 'CREATE_HOME_WIDGET_BANNER';

const createHomeWidgetBannerApi = createApiCall<{ payload: any }>(
  CREATE_HOME_WIDGET_BANNER,
  ({ payload }) => ({
    endpoint: `api/admin/home-widget-banners`,
    method: 'POST',
    body: payload,
  })
);

export default createHomeWidgetBannerApi;
